// You can write more code here

/* START OF COMPILED CODE */

import DefaultConfirmButton_m from '../DefaultConfirmButton_m';
import DefaultButton from '../GeneralUI/Buttons/DefaultButton';
import MentorUI from '../GeneralUI/MentorUI';
import UIBlocker from '../GeneralUI/UIBlocker';
/* START-USER-IMPORTS */
import { BiomeNames, MentorNames } from '@/common/types/LectioTypes';
import { mentorAudioService, playRealmIntro } from '@/common/utils/audio';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import {
  getAnchorPlugin,
  getBiomeFromStudentLevel,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
/* END-USER-IMPORTS */

export default class MentorIntroductionPanel
  extends Phaser.GameObjects.Container
{
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker);

    // desktopView
    const desktopView = scene.add.container(0, 0);
    desktopView.visible = false;
    this.add(desktopView);

    // mainContainer
    const mainContainer = scene.add.container(512, 384);
    desktopView.add(mainContainer);

    // mainBacking
    const mainBacking = scene.add.nineslice(
      128,
      0,
      'Hud1',
      undefined,
      128,
      128,
      8,
      8,
      8,
      8,
    );
    mainBacking.scaleX = 4;
    mainBacking.scaleY = 4;
    mainContainer.add(mainBacking);

    // mentorUI
    const mentorUI = new MentorUI(scene, -296, 32, 'npc_mentor_e_portrait');
    mentorUI.scaleX = 0.4;
    mentorUI.scaleY = 0.4;
    mainContainer.add(mentorUI);

    // continueButton
    const continueButton = new DefaultButton(scene, 128, 208);
    mainContainer.add(continueButton);

    // description
    const description = scene.add.bitmapText(
      -48,
      120,
      'Aronui',
      'Talk to locals to practice your Spellcasting and Dueling!',
    );
    description.setOrigin(0, 0.5);
    description.tintTopLeft = 5387071;
    description.tintTopRight = 5387071;
    description.tintBottomLeft = 5387071;
    description.tintBottomRight = 5387071;
    description.text =
      'Talk to locals to practice your Spellcasting and Dueling!';
    description.fontSize = -18;
    description.maxWidth = 380;
    mainContainer.add(description);

    // npcImage
    const npcImage = scene.add.image(128, -16, 'tutorialScreenshot');
    npcImage.scaleX = 0.5;
    npcImage.scaleY = 0.5;
    mainContainer.add(npcImage);

    // newMentorLabel
    const newMentorLabel = scene.add.bitmapText(
      -48,
      -176,
      'Aronui',
      'New mentor:',
    );
    newMentorLabel.setOrigin(0, 0.5);
    newMentorLabel.tintTopLeft = 5387071;
    newMentorLabel.tintTopRight = 5387071;
    newMentorLabel.tintBottomLeft = 5387071;
    newMentorLabel.tintBottomRight = 5387071;
    newMentorLabel.text = 'New mentor:';
    newMentorLabel.fontSize = -18;
    newMentorLabel.maxWidth = 300;
    mainContainer.add(newMentorLabel);

    // newMentorText
    const newMentorText = scene.add.bitmapText(
      -48,
      -152,
      'Aronui',
      'Guardian Greenleaf',
    );
    newMentorText.setOrigin(0, 0.5);
    newMentorText.tintTopLeft = 15091001;
    newMentorText.tintTopRight = 15091001;
    newMentorText.tintBottomLeft = 15091001;
    newMentorText.tintBottomRight = 15091001;
    newMentorText.text = 'Guardian Greenleaf';
    newMentorText.fontSize = -18;
    newMentorText.maxWidth = 300;
    mainContainer.add(newMentorText);

    // newRealmLabel
    const newRealmLabel = scene.add.bitmapText(
      184,
      -176,
      'Aronui',
      'New realm:',
    );
    newRealmLabel.setOrigin(0, 0.5);
    newRealmLabel.tintTopLeft = 5387071;
    newRealmLabel.tintTopRight = 5387071;
    newRealmLabel.tintBottomLeft = 5387071;
    newRealmLabel.tintBottomRight = 5387071;
    newRealmLabel.text = 'New realm:';
    newRealmLabel.fontSize = -18;
    newRealmLabel.maxWidth = 300;
    mainContainer.add(newRealmLabel);

    // newRealmText
    const newRealmText = scene.add.bitmapText(184, -152, 'Aronui', 'Forest');
    newRealmText.setOrigin(0, 0.5);
    newRealmText.tintTopLeft = 15091001;
    newRealmText.tintTopRight = 15091001;
    newRealmText.tintBottomLeft = 15091001;
    newRealmText.tintBottomRight = 15091001;
    newRealmText.text = 'Forest';
    newRealmText.fontSize = -18;
    newRealmText.maxWidth = 300;
    mainContainer.add(newRealmText);

    // headerContainer
    const headerContainer = scene.add.container(128, -248);
    mainContainer.add(headerContainer);

    // headerBacking
    const headerBacking = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      92,
      18,
      4,
      4,
      4,
      4,
    );
    headerBacking.scaleX = 4;
    headerBacking.scaleY = 4;
    headerContainer.add(headerBacking);

    // titleText
    const titleText = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Welcome, Spellcaster!',
    );
    titleText.setOrigin(0.5, 0.5);
    titleText.tintTopLeft = 985612;
    titleText.tintTopRight = 985612;
    titleText.tintBottomLeft = 985612;
    titleText.tintBottomRight = 985612;
    titleText.text = 'Welcome, Spellcaster!';
    titleText.fontSize = -30;
    headerContainer.add(titleText);

    // mobileView
    const mobileView = scene.add.container(0, 0);
    this.add(mobileView);

    // mainContainer_m
    const mainContainer_m = scene.add.container(339, 188);
    mobileView.add(mainContainer_m);

    // mainBacking_m
    const mainBacking_m = scene.add.nineslice(
      85,
      0,
      'Hud1',
      undefined,
      200,
      160,
      8,
      8,
      8,
      8,
    );
    mainBacking_m.scaleX = 2;
    mainBacking_m.scaleY = 2;
    mainContainer_m.add(mainBacking_m);

    // mentorUI_m
    const mentorUI_m = new MentorUI(scene, -211, 172, 'npc_mentor_e_portrait');
    mentorUI_m.scaleX = 0.4;
    mentorUI_m.scaleY = 0.4;
    mainContainer_m.add(mentorUI_m);

    // continueButton_m
    const continueButton_m = new DefaultConfirmButton_m(scene, 81, 120);
    mainContainer_m.add(continueButton_m);

    // description_m
    const description_m = scene.add.bitmapText(
      85,
      64,
      'Aronui',
      'Talk to locals to practice your Spellcasting and Dueling!',
    );
    description_m.setOrigin(0.5, 0.5);
    description_m.tintTopLeft = 5387071;
    description_m.tintTopRight = 5387071;
    description_m.tintBottomLeft = 5387071;
    description_m.tintBottomRight = 5387071;
    description_m.text =
      'Talk to locals to practice your Spellcasting and Dueling!';
    description_m.fontSize = -16;
    description_m.align = 1;
    description_m.maxWidth = 330;
    mainContainer_m.add(description_m);

    // npcImage_m
    const npcImage_m = scene.add.image(85, -24, 'tutorialScreenshot');
    npcImage_m.scaleX = 0.3;
    npcImage_m.scaleY = 0.3;
    mainContainer_m.add(npcImage_m);

    // newMentorLabel_m
    const newMentorLabel_m = scene.add.bitmapText(
      -51,
      -116,
      'Aronui',
      'New mentor:',
    );
    newMentorLabel_m.setOrigin(0, 0.5);
    newMentorLabel_m.tintTopLeft = 5387071;
    newMentorLabel_m.tintTopRight = 5387071;
    newMentorLabel_m.tintBottomLeft = 5387071;
    newMentorLabel_m.tintBottomRight = 5387071;
    newMentorLabel_m.text = 'New mentor:';
    newMentorLabel_m.fontSize = -16;
    newMentorLabel_m.maxWidth = 300;
    mainContainer_m.add(newMentorLabel_m);

    // newMentorText_m
    const newMentorText_m = scene.add.bitmapText(
      -51,
      -100,
      'Aronui',
      'Guardian Greenleaf',
    );
    newMentorText_m.setOrigin(0, 0.5);
    newMentorText_m.tintTopLeft = 15091001;
    newMentorText_m.tintTopRight = 15091001;
    newMentorText_m.tintBottomLeft = 15091001;
    newMentorText_m.tintBottomRight = 15091001;
    newMentorText_m.text = 'Guardian Greenleaf';
    newMentorText_m.fontSize = -16;
    newMentorText_m.maxWidth = 300;
    mainContainer_m.add(newMentorText_m);

    // newRealmLabel_m
    const newRealmLabel_m = scene.add.bitmapText(
      145,
      -116,
      'Aronui',
      'New realm:',
    );
    newRealmLabel_m.setOrigin(0, 0.5);
    newRealmLabel_m.tintTopLeft = 5387071;
    newRealmLabel_m.tintTopRight = 5387071;
    newRealmLabel_m.tintBottomLeft = 5387071;
    newRealmLabel_m.tintBottomRight = 5387071;
    newRealmLabel_m.text = 'New realm:';
    newRealmLabel_m.fontSize = -16;
    newRealmLabel_m.maxWidth = 300;
    mainContainer_m.add(newRealmLabel_m);

    // newRealmText_m
    const newRealmText_m = scene.add.bitmapText(145, -100, 'Aronui', 'Forest');
    newRealmText_m.setOrigin(0, 0.5);
    newRealmText_m.tintTopLeft = 15091001;
    newRealmText_m.tintTopRight = 15091001;
    newRealmText_m.tintBottomLeft = 15091001;
    newRealmText_m.tintBottomRight = 15091001;
    newRealmText_m.text = 'Forest';
    newRealmText_m.fontSize = -16;
    newRealmText_m.maxWidth = 300;
    mainContainer_m.add(newRealmText_m);

    // headerContainer_m
    const headerContainer_m = scene.add.container(85, -156);
    mainContainer_m.add(headerContainer_m);

    // headerBacking_m
    const headerBacking_m = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      150,
      22,
      4,
      4,
      4,
      4,
    );
    headerBacking_m.scaleX = 2;
    headerBacking_m.scaleY = 2;
    headerContainer_m.add(headerBacking_m);

    // titleText_m
    const titleText_m = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Welcome, Spellcaster!',
    );
    titleText_m.setOrigin(0.5, 0.5);
    titleText_m.tintTopLeft = 985612;
    titleText_m.tintTopRight = 985612;
    titleText_m.tintBottomLeft = 985612;
    titleText_m.tintBottomRight = 985612;
    titleText_m.text = 'Welcome, Spellcaster!';
    titleText_m.fontSize = -24;
    headerContainer_m.add(titleText_m);

    // continueButton (prefab fields)
    continueButton.buttonText = 'OK!';

    // continueButton_m (prefab fields)
    continueButton_m.buttonText = 'Continue';

    this.continueButton = continueButton;
    this.newMentorText = newMentorText;
    this.newRealmText = newRealmText;
    this.mainContainer = mainContainer;
    this.desktopView = desktopView;
    this.continueButton_m = continueButton_m;
    this.newMentorText_m = newMentorText_m;
    this.newRealmText_m = newRealmText_m;
    this.mainContainer_m = mainContainer_m;
    this.mobileView = mobileView;

    /* START-USER-CTR-CODE */

    this.initialize();
    /* END-USER-CTR-CODE */
  }

  public continueButton: DefaultButton;
  public newMentorText: Phaser.GameObjects.BitmapText;
  public newRealmText: Phaser.GameObjects.BitmapText;
  private mainContainer: Phaser.GameObjects.Container;
  public desktopView: Phaser.GameObjects.Container;
  public continueButton_m: DefaultConfirmButton_m;
  public newMentorText_m: Phaser.GameObjects.BitmapText;
  public newRealmText_m: Phaser.GameObjects.BitmapText;
  private mainContainer_m: Phaser.GameObjects.Container;
  public mobileView: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  initialize() {
    this.getResponsiveElements('continueButton').forEach(
      (continueButton: DefaultButton) => {
        continueButton.controller.setSubmissionCallback(() => {
          this.setVisible(false);
          mentorAudioService.stopAudio();
          EventBus.emit(GAME_EVENTS.MENTOR_INTRODUCTION_PANEL_CLOSED);
        });
      },
    );

    this.initializeResponsiveness();
  }

  getResponsiveElements(key: keyof MentorIntroductionPanel) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  open() {
    this.setVisible(true);
    const biome = getBiomeFromStudentLevel(getStudent().level);

    this.getResponsiveElements('newMentorText').forEach(
      (mentorName: Phaser.GameObjects.BitmapText) => {
        mentorName.setText(MentorNames[biome]);
      },
    );
    this.getResponsiveElements('newRealmText').forEach(
      (biomeName: Phaser.GameObjects.BitmapText) => {
        biomeName.setText(BiomeNames[biome]);
      },
    );

    playRealmIntro(MentorNames[biome]);
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      anchor.add(this.desktopView, {
        top: '0%',
        left: '0%',
      });
      anchor.add(this.mainContainer, {
        centerX: '50%',
        centerY: '50%',
      });

      anchor.add(this.mobileView, {
        top: '0%',
        left: '0%',
      });
      anchor.add(this.mainContainer_m, {
        centerX: '50%-8',
        centerY: '50%',
      });
    }

    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.mainContainer);
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.mainContainer_m,
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
